// eslint-disable-next-line @nx/enforce-module-boundaries
import { IResource, LkResourceActions, Role } from '@admin-panel/access-control';
import { PORTAL_NAME } from '@admin-panel/config/env';
import { AccessControlProvider, CanParams, CanResponse } from '@refinedev/core';

export class AccessControlClient {
  allowedResourceActions: LkResourceActions | undefined;

  accessControlProvider: AccessControlProvider = {
    can: async ({ resource, action, params }: CanParams): Promise<CanResponse> => {
      // console.log('check permissions for ', resource, ' for action ', action);
      // console.log('mappings found ', this.allowedResourceActions);
      if (resource && this.allowedResourceActions) {
        let allowedActions = this.allowedResourceActions['*'];
        if (allowedActions && allowedActions.length > 0) return { can: true };

        allowedActions = this.allowedResourceActions[resource];
        if (allowedActions && (allowedActions.includes('*') || allowedActions.includes(action)))
          return { can: true };
      }
      return { can: false };
    },
    options: {
      buttons: {
        enableAccessControl: true,
        hideIfUnauthorized: true,
      },
      queryOptions: {
        retry: 1,
      },
    },
  };

  public getAccessControlProvider() {
    return this.accessControlProvider;
  }

  public loadPermissionsContext(resources: Array<IResource>, userRoles: Array<Role>) {
    const allowedResourceActions: LkResourceActions = {};

    if (
      userRoles.includes('SUPER_ADMIN') ||
      (PORTAL_NAME === 'vendor' && userRoles.includes('NEXUS_SUPER_ADMIN'))
    ) {
      allowedResourceActions['*'] = ['*'];
    }

    resources.forEach(resource => {
      if (!resource.meta) {
        return;
      }

      resource.meta.masterRoles?.forEach(role => {
        if (role !== '*' && !userRoles.includes(role)) {
          return;
        }

        allowedResourceActions[resource.name] = ['*'];
      });

      Object.entries(resource.meta?.permissions || {}).forEach(([action, definedRoles]) => {
        definedRoles?.forEach(role => {
          if (role !== '*' && !userRoles.includes(role)) {
            return;
          }

          let allowedActions = allowedResourceActions[resource.name];
          if (!allowedActions) allowedActions = [];

          allowedActions.push(action);
          allowedResourceActions[resource.name] = allowedActions;
        });
      });
    });

    // console.table(allowedResourceActions);
    this.allowedResourceActions = allowedResourceActions;
  }
}
